import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './compnents/PrivateRoute';
import Datasets from './pages/Datasets';
import Settings from './pages/Settings';
import NotFound from './compnents/NotFound';
import ManageCustomers from './pages/ManageCustomers';
import ApiKey from './pages/ApiKey';
import Personalization from './pages/Personalization';
import ReportsExports from './pages/ReportsExports';
import AuditCompliance from './pages/AuditCompliance';
import Docs from './compnents/Docs';

function App() {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/datasets"
        element={
          <PrivateRoute>
            <Datasets />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/apiKey"
        element={
          <PrivateRoute>
            <ApiKey />
          </PrivateRoute>
        }
      />
      <Route
        path="/personalization"
        element={
          <PrivateRoute>
            <Personalization />
          </PrivateRoute>
        }
      />
      <Route
        path="/reportsExports"
        element={
          <PrivateRoute>
            <ReportsExports />
          </PrivateRoute>
        }
      />
      <Route
        path='/auditCompliance'
        element={
          <PrivateRoute>
            <AuditCompliance />
          </PrivateRoute>
        }
      />
      <Route
        path='/settings/manageCustomers'
        element={
          <PrivateRoute>
            <ManageCustomers />
          </PrivateRoute>
        }
      />
      {/* for developer docs */}
      <Route
        path='/docs'
        element={
          <Docs/>
        }
      />
    </Routes>
  );
}

export default App;